import { Component, OnInit } from '@angular/core';
import { Observable } from "rxjs";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { process, State } from "@progress/kendo-data-query";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";
import { TagService } from "../../../core/_services/tag.service";

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.sass']
})
export class TagsComponent implements OnInit {

  public view: Observable<GridDataResult>;
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 10
  };

  constructor(
    private _tagService: TagService,
    private _router: Router,
  ) {

  }

  ngOnInit() {
    this.view = this._tagService.pipe(map(data => process(data, this.gridState)));
    this._tagService.refresh();
  }

  public onStateChange(state: State) {
    this.gridState = state;
    this._tagService.read();
  }

  public editModel({sender, rowIndex, dataItem}) {
    this._router.navigate(['/panel/tag', {uuid: dataItem.uuid}]);
  }


}




